module.exports = __webpack_public_path__ + "images/fa-fw2024-bg-pricing.webp";